import { json, postBiz, rows } from '../core/coreapi';

const SERVICE = 'determinantreportissue';

/**
 * Find report issues for a Determinant Budget.
 * `dbi` is the Determinant Budget id. `rid` is reserved for an issue record.
 */
export const findDeterminantReportIssues = async (
  determinantbudgetid: number,
  status: '' | 'OPEN' | 'RESOLVED' = 'OPEN',
  pageoffset = 0,
  pagelimit = 100,
): Promise<any[]> =>
  rows(
    await postBiz({ 
      s: SERVICE,
      a: 'find',
      dbi: determinantbudgetid,
      sta: status || null,
      pos: pageoffset,
      plm: pagelimit,
    })
  );

export const resolveDeterminantReportIssue = async (
  issueid: number,
  resolution: string,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'resolve',
      isi: issueid,
      rsn: resolution,
    })
  );
